import { defineComponent as V, openBlock as o, createElementBlock as e, mergeProps as p, unref as n, renderSlot as i, createElementVNode as l, createCommentVNode as u } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, A = { key: 1 }, Z = { key: 2 }, f = { key: 3 }, k = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconRectangle"
}, _ = /* @__PURE__ */ V({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: H, weight: a } = m(s);
    return (d, t) => (o(), e("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(H)), [
      i(d.$slots, "default"),
      n(a) === "bold" ? (o(), e("g", g, t[0] || (t[0] = [
        l("path", { d: "M216,36H40A20,20,0,0,0,20,56V200a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36Zm-4,160H44V60H212Z" }, null, -1)
      ]))) : n(a) === "duotone" ? (o(), e("g", A, t[1] || (t[1] = [
        l("path", {
          d: "M224,56V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200Z" }, null, -1)
      ]))) : n(a) === "fill" ? (o(), e("g", Z, t[2] || (t[2] = [
        l("path", { d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z" }, null, -1)
      ]))) : n(a) === "light" ? (o(), e("g", f, t[3] || (t[3] = [
        l("path", { d: "M216,42H40A14,14,0,0,0,26,56V200a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42Zm2,158a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2Z" }, null, -1)
      ]))) : n(a) === "regular" ? (o(), e("g", k, t[4] || (t[4] = [
        l("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200Z" }, null, -1)
      ]))) : n(a) === "thin" ? (o(), e("g", h, t[5] || (t[5] = [
        l("path", { d: "M216,44H40A12,12,0,0,0,28,56V200a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44Zm4,156a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H216a4,4,0,0,1,4,4Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  _ as default
};
